import { StyleSheet, Platform } from 'react-native';

/** Onboarding-design tokens (dark stadium hero + purple accent). */
const ACCENT = '#A78BFA';
const ACCENT_HOVER = '#b9a3fb';
const CTA_INK = '#111827';
const HERO_FALLBACK_BG = '#0F0A1A';
const SUBLINE_COLOR = '#9CA3AF';
const SECONDARY_BORDER = '#374151';

/** Bottom-darkening scrim over the hero image so the wordmark + CTAs stay readable. */
export const WELCOME_SCRIM_COLORS = [
  'rgba(10, 7, 19, 0.12)',
  'rgba(10, 7, 19, 0.55)',
  'rgba(10, 7, 19, 0.9)',
] as const;
export const WELCOME_SCRIM_LOCATIONS = [0, 0.55, 1] as const;

export const welcomeStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: HERO_FALLBACK_BG,
  },
  backgroundImage: {
    ...StyleSheet.absoluteFillObject,
  },
  scrim: {
    ...StyleSheet.absoluteFillObject,
  },
  content: {
    flex: 1,
    justifyContent: 'space-between',
    zIndex: 1,
  },
  hero: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingHorizontal: 32,
    paddingTop: 24,
    gap: 10,
  },
  mascot: {
    marginBottom: 4,
  },
  subline: {
    fontSize: 16,
    lineHeight: 22,
    fontWeight: '500',
    color: SUBLINE_COLOR,
    textAlign: 'center',
    marginTop: 4,
  },
  actions: {
    width: '100%',
    maxWidth: 440,
    alignSelf: 'center',
    paddingHorizontal: 22,
    paddingBottom: 30,
    gap: 12,
  },
  primaryButton: {
    backgroundColor: ACCENT,
    borderRadius: 12,
    minHeight: 54,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    ...Platform.select({
      ios: {
        shadowColor: ACCENT,
        shadowOpacity: 0.35,
        shadowRadius: 14,
        shadowOffset: { width: 0, height: 2 },
      },
      android: { elevation: 6 },
      default: {},
    }),
  },
  primaryButtonPressed: {
    transform: [{ scale: 0.97 }],
  },
  primaryButtonHoveredWeb: {
    backgroundColor: ACCENT_HOVER,
  },
  primaryButtonText: {
    fontSize: 16,
    fontWeight: '700',
    color: CTA_INK,
    textAlign: 'center',
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    borderRadius: 12,
    minHeight: 54,
    borderWidth: 1.5,
    borderColor: SECONDARY_BORDER,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  secondaryButtonPressed: {
    transform: [{ scale: 0.97 }],
    opacity: 0.85,
  },
  secondaryButtonHoveredWeb: {
    backgroundColor: 'rgba(167, 139, 250, 0.08)',
  },
  secondaryButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: ACCENT,
    textAlign: 'center',
  },
});
